import { combineReducers } from "redux";
import authReducer from "./authReducer";
import notificationReducer from "./notificationReducer";
import commonReducer from "./commonReducer";
import candidateListReducer from "./candidateReducer";
import projectLaunchReducer from "./projectLauchReducer";
import mpLaunchesReducer from "./mpLaunchesReducer";
import recruitmentReducer from "./recruitmentReducer";
import tabReducer from "./tabReducer";


const rootReducers = combineReducers({
  auth: authReducer,
  notification: notificationReducer,
  common: commonReducer,
  candidates: candidateListReducer,
  projectLaunch:projectLaunchReducer,
  mpLaunch:mpLaunchesReducer,
  recruit:recruitmentReducer,
   tab: tabReducer,
});

export default rootReducers;
